import {Card, Stack, styled} from '@mui/material';

const StyledCard = styled(Card)`
	display: flex;
	padding: 8px 16px;
	flex-direction: column;
	align-items: flex-start;
	gap: 8px;
	height: 100%;
	box-shadow: none;
	border: 1px solid ${({theme}) => theme.colors.gray.A10Percent};
`;

const StyledDataContent = styled(Stack)`
	gap: 8px;
	padding-block: 8px;
	flex: 1;
	width: 100%;

	border-bottom: 1px solid ${({theme}) => theme.colors.gray.A10Percent};
`;

export {StyledCard, StyledDataContent};
